import { resources } from './resources'

export const getOptions = () => ({
  resources,
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['path'],
  },
})
